import { useContextSelector } from 'use-context-selector';

import { FeatureFlagContext } from '@/context/FeatureFlagContext/FeatureFlagContext';

export function useFeatureFlags() {
  const featureFlags = useContextSelector(FeatureFlagContext, (state) => state.featureFlags);
  const loading = useContextSelector(FeatureFlagContext, (state) => state.loading);
  const setFeatureFlags = useContextSelector(FeatureFlagContext, (state) => state.setFeatureFlags);

  return {
    featureFlags,
    loading,
    setFeatureFlags,
  };
}
